<template>
  <div :class="{'nav-open': $sidebar.showSidebar}" v-if="!refresh">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
import ppeBusiness from 'ppe-business';

  export default {
    data() {
      return {
        refresh: false
      }
    },

    methods: {
        // Use a hack: https://plainenglish.io/blog/many-ways-to-rerender-a-vue-component-660376d94cc1
        reload() {
        // toggle the render condition to false and then toggle it back to true in the next update cycle
        this.refresh = true;
        this.$nextTick(() => {
          this.refresh = false;
        });
      }
    },

    async mounted() {
      this.$eventbus.$on('on-editlabel-done', (label) => {
        console.log("Application Vue.on:", label)
        
        // Do not await
        this.$http.post("/admin/resourcesstring", {key:label.resourcekey, text:label.text});
        // Affect the cache
        ppeBusiness.resources.strings[label.resourcekey] = label.text
      });

      this.$eventbus.$on('on-force-refesh-page', ()=>{

        console.log("on-force-refesh-page", this.$router.currentRoute)
        // Use a hack: https://plainenglish.io/blog/many-ways-to-rerender-a-vue-component-660376d94cc1
        this.reload()

      })

      // Load the resources from the server
      let response = await this.$http.get('/admin/resourcesstrings')
      //console.log("response.data", response.data.strings)

      ppeBusiness.resources.strings = response.data.strings
      
  }
}

</script>

<style>
  .control-label, .form-group label {
    text-transform: initial !important;
    font-size: 14px !important;
  }

  .fixed {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: white;
    border-bottom: solid 1px lightgray;
  }
  
</style>

